<template lang="html">
  <div id="auth">
    <img src="../../assets/D-CIPHER-A_logo.svg">
    <p>
      Whatever your role, everyone wants to create experiences customers love, 
      and <strong>people love experiences that <em>flow</em>.</strong><br>
      The problem is, how to effectively maximize flow? How can you compare one software's flow over another?
    </p>
    <p>
      So we created the first <em>method</em> and <em>toolset</em> that <strong>empirically measures UX flow</strong>.<br>
      This new approach will help you discover and <strong>gain insights</strong>, identify and dramatically 
      <strong>reduce friction</strong>, and produce maximize flow.<br>
      Apply this method today and <strong>design flowing experiences customers love</strong>!
    </p>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import firebaseui from 'firebaseui'
import router from '../../lib/router/router'

export default {
  name: 'Auth',
  mounted() {
    const uiConfig = {
      signInOptions: [firebase.auth.EmailAuthProvider.PROVIDER_ID],
      callbacks: {
        signInSuccessWithAuthResult: authResult => {
          if (authResult.user) {
            router.push(`/users/${authResult.user.uid}/projects/1/sessions/1/events/0`)
            return false
          }
          return true
        },
      },
    }
    firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.SESSION)
      .then(() => {
        const ui = new firebaseui.auth.AuthUI(firebase.auth())
        ui.start('#auth', uiConfig)
      })
  },
}
</script>

<style lang="scss">
#auth {
  text-align: center;

  > p {
    width: 100%;
    font-size: 140%;
    line-height: 1.8em;
    margin: 0 0 15px;
  }

  > img {
    width: 500px;
    margin: 30vh 0 0;
  }

  > .firebaseui-container {
    position: fixed;
    top: 0;
    left: 50%;
    margin: 0 0 0 -180px;
  }

  .mdl-button--raised.mdl-button--colored {
    background: #3f51b5;
  }
}
</style>
